import React, { Component } from 'react';
import { Row, Col, FormGroup, Label, Input, Button, Collapse, Modal, ModalHeader, ModalBody } from 'reactstrap';
import BoardMemberEdit from '../BoardMembers/BoardMemberEdit';
import EditProfile from '../Profiles/EditProfile';

export default class AdminApplication extends Component {
    constructor(props) {
        super(props)

        this.state = { application: { board: {}, profile: {}, applicationAttachments: [] }, collapse: false, showFinializeModal: false };
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        fetch('api/applications/' + id, {
            method: 'GET'
        })
        .then(resp => resp.json())
        .then(data => {
            if(data.submitDate) {
                data.submitDate = data.submitDate.substring(0, data.submitDate.indexOf('T'));
            }
            if(data.finishDate) {
                data.finishDate = data.finishDate.substring(0, data.finishDate.indexOf('T'));
            }
            if(data.swearingInAppointmentDate) {
                data.swearingInAppointmentDate = data.swearingInAppointmentDate.substring(0, data.swearingInAppointmentDate.indexOf('T'));
            }

            this.setState({ application: data })
        })
    }

    getNextStatus = (currentStatus) => {
        switch(currentStatus) {
            case 'Pending':
                return 'Under Review';
            case 'Under Review':
                return 'Awaiting County Excecutive Approval';
            case 'Awaiting County Excecutive Approval':
                if(this.state.application.board.councilConfirmation) {
                    return 'Awaiting County Council Confirmation';
                } else {
                    return 'Scheduling Swearing In';
                }
            case 'Awaiting County Council Confirmation':
                return 'Scheduling Swearing In';
            case 'Scheduling Swearing In':
                return 'Awaiting Swearing In'
            case 'Awaiting Swearing In':
                return 'Approved';
            default:
                return 'Pending';
        }
    }

    setCollapse = () => {
        this.setState({ collapse: !this.state.collapse });
    }

    rejectApplication = () => {
        let { application } = this.state;
        application.status = 'Rejected';
        let today = new Date();
        application.finishDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        fetch('api/applications/' + this.state.application.id, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(application)
        })
        .then(response => {
            if(response.ok) {
                
                this.setState({ id: this.state.application.id, application: application });
            } else {
                alert('Could not save changes to the database at this time.  Please try again later.');
            }
        })
    }

    advanceApplicationStatus = () => {
        let application = this.state.application;
        let nextStatus = this.getNextStatus(this.state.application.status);
        
        if(nextStatus === 'Awaiting Swearing In' && !application.swearingInAppointmentDate) {
            alert('You must select a swearing in appointment date.');
            return;
        }
        if(nextStatus === 'Approved') {
            this.toggleFinalizeMemberModal()
        } else {
            application.status = nextStatus;
            fetch('api/applications/' + application.id, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(application)
            })
            .then(response => {
                if(response.ok) {
                    this.setState({ application: application });
                } else {
                    alert('Could not save changes to the database at this time.  Please try again later.');
                }
            })
        }
    }

    toggleFinalizeMemberModal = () => {
        this.setState({ showFinializeModal: !this.state.showFinializeModal });
    }

    finializeMember = () => {
        var today = new Date()

        let { application } = this.state;
        application.status = 'Approved'
        application.finishDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        fetch('api/applications/' + application.id, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(application)
        })
        .then(response => {
            if(response.ok) {
                this.props.history.push('/admin/boards/' + application.boardId);
            } else {
                alert('Could not save changes to the application in the database at this time.  Please try again later.');
            }
        })
    }

    handleChange = (e) => {
        let { application } = this.state;
        application[e.target.name] = e.target.value;
        this.setState({ application: application });
    }

    render() {
        const { application, collapse } = this.state;
        let swearInReadonly = true;

        if(application.status === 'Scheduling Swearing In') {
            swearInReadonly = false;
        }
        console.log(this.state)
        return(
            
            <div>
                <Modal size='lg' isOpen={this.state.showFinializeModal} backdrop='static'>
                    <ModalHeader>Finialize Board Member - {application.profile.firstName + ' ' + application.profile.lastName}</ModalHeader>
                    <ModalBody>
                        <BoardMemberEdit createNew onFinalizeSuccess={this.finializeMember} boardId={application.boardId} profileId={application.profileId} />
                    </ModalBody>
                </Modal>
                <Row>
                    <Col sm='11'>
                        <h4>{application.board.name} - {application.profile.firstName + ' ' + application.profile.lastName}</h4>
                    </Col>
                    <Col sm='1'>
                        <Button color='secondary' className='my-2' onClick={this.setCollapse}>Help</Button>
                    </Col>
                </Row>

                <Collapse isOpen={collapse}>
                    <Row>
                        <div className='m-4 p-2' style={{border: 'solid grey 2px', borderRadius: '4px', backgroundColor: 'lightGrey'}}>
                            <p>Rejecting an application will change the status to 'Rejected' and it will no longer be availible from the Board Edit screen.  An application can be rejected at any time in the process.</p>
                            <p>The status order is as follows:</p>
                            <ul>
                                <li>Pending</li>
                                <li>Under Review</li>
                                <li>Awaiting County Excecutive Approval</li>
                                <li>Awaiting County Council Confirmation (Only if the board requires it)</li>
                                <li>Scheduling Swearing In</li>
                                <li>Awaiting Swearing In</li>
                                <li>Approved</li>
                            </ul>
                        </div>
                    </Row>
                </Collapse>

                <Row>
                    <Col sm='8'>
                        <Button color='danger' onClick={this.rejectApplication}>Reject Application</Button>
                    </Col>
                    <Col sm='4' style={{textAlign: 'right'}}>
                        <Button color='primary' onClick={this.advanceApplicationStatus}>Change Status to: {this.getNextStatus(application.status)}</Button>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col sm='6'>
                        <FormGroup>
                            <Label for='status'>Application Status</Label>
                            <Input name='status' readOnly value={application.status || ''} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='4'>
                        <FormGroup>
                            <Label for='submitDate'>Submission Date</Label>
                            <Input name='submitDate' type='date' readOnly value={application.submitDate || ''} />
                        </FormGroup>
                    </Col>
                    <Col sm='4'>
                        <FormGroup>
                            <Label for='finishDate'>Finish Date</Label>
                            <Input name='finishDate' type='date' readOnly value={application.finishDate || ''} />
                        </FormGroup>
                    </Col>
                    <Col sm='4'>
                        <FormGroup>
                            <Label for='swearingInAppointmentDate'>Swearing In Appointment Date</Label>
                            <Input required type='date' name='swearingInAppointmentDate' readOnly={swearInReadonly} value={application.swearingInAppointmentDate || ''} onChange={this.handleChange} />
                        </FormGroup>
                    </Col>
                </Row>
                {application.applicationAttachments.length > 0 &&
                    <div className='form-border mb-2'>
                        <h5>Attachments to the Application</h5>
                        <Row>
                            <Col sm='6'>
                                <strong>Type</strong>
                            </Col>
                            <Col sm='6'>
                                <strong>File Name</strong>
                            </Col>
                        </Row>
                        {application.applicationAttachments.map(item => {
                            return(
                                <Row>
                                    <Col sm='6'>
                                        {item.type}
                                    </Col>
                                    <Col sm='6'>
                                        {item.displayName}
                                    </Col>
                                </Row>
                            )
                        })}
                    </div>
                }
                {application.profileSnapshot &&
                    <EditProfile profile={application.profileSnapshot} />
                }
            </div>
        )
    }
}